/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const publishOnboardingChallengesResultSchema = z.object({
  published: z.number(),
  ids: z.array(z.number()),
});

export type IPublishOnboardingChallengesResult = z.infer<
  typeof publishOnboardingChallengesResultSchema
>;

export const publishOnboardingChallengesResponseSchema = createApiResponseSchema(
  publishOnboardingChallengesResultSchema,
) as z.ZodSchema<IAPI<IPublishOnboardingChallengesResult>>;

export type IPublishOnboardingChallengesResponse = IAPI<IPublishOnboardingChallengesResult>;
